'use client';
import { WarningIcon } from '@/components/icons';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({ resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-50'>
      <div className='p-8 text-center'>
        <div className='flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full'>
          <WarningIcon className='w-8 h-8 text-red-600' />
        </div>
        <h2 className='mb-2 text-xl font-semibold text-gray-900'>
          Something went wrong
        </h2>
        <p className='mb-4 text-gray-600'>
          We're sorry, but something unexpected happened.
        </p>
        <button
          onClick={resetErrorBoundary}
          className='px-4 py-2 text-white transition-colors rounded-md bg-brand-teal hover:bg-brand-navy'
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export function GoogleOAuthErrorFallback({
  resetErrorBoundary,
}: ErrorFallbackProps) {
  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-50'>
      <div className='p-8 text-center'>
        <div className='flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-yellow-100 rounded-full'>
          <WarningIcon className='w-8 h-8 text-yellow-600' />
        </div>
        <h2 className='mb-2 text-xl font-semibold text-gray-900'>
          Authentication Unavailable
        </h2>
        <p className='mb-4 text-gray-600'>
          Google sign-in is temporarily unavailable. Please try again later.
        </p>
        <button
          onClick={resetErrorBoundary}
          className='px-4 py-2 text-white transition-colors rounded-md bg-brand-teal hover:bg-brand-navy'
        >
          Try again
        </button>
      </div>
    </div>
  );
}
